import { useState } from 'react';
import { addPosLead } from '@/lib/contact';

// Add to POS Leads (Gary, 3 Nov 2026, option B): a Peace of Sleep chat nobody matched becomes a POS lead with the
// property the POS team types. Never automatic, so POS Leads holds real properties only.

export function PosLeadSheet({ chatId, onDone }: { chatId: string; onDone: (message: string) => void }) {
  const [property, setProperty] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const valid = property.trim().length >= 2;

  const save = () => {
    setBusy(true); setError(null);
    addPosLead(chatId, property.trim())
      .then(() => onDone('Added to POS Leads'))
      .catch((e: unknown) => { setError(e instanceof Error ? e.message : 'That did not save. Try again.'); setBusy(false); });
  };

  return (
    <div className="chats-pad">
      <h2 className="chats-sheet-title">Add to POS Leads</h2>
      <p className="chats-sheet-hint">The property this chat is about. Their number is saved as its contact.</p>
      {error && <p className="chats-rec-error" role="alert">{error}</p>}
      <input className="chats-input chats-input--stack" autoFocus maxLength={120} value={property} onChange={(e) => setProperty(e.target.value)}
        placeholder="Property, e.g. Oak Lodge" aria-label="Property name" />
      <button type="button" className="chats-btn" disabled={busy || !valid} onClick={save}>{busy ? 'Adding...' : 'Add to POS Leads'}</button>
    </div>
  );
}
